import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** BrowserRouter keeps the scroll position across client-side navigations - reset it. */
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
